import * as ko from "knockout";
import Template from 'Core/GeneralProperties/Managers/DWPackageProperty/Templates/DWPackageProperty.html';

import { Notifier } from 'Core/Common/Notifier';
import { BaseProperty, IPropertyDescription, IPropertyOption } from "Core/GeneralProperties/Managers/BaseProperty";
import { DWPackageModel } from "Core/GeneralProperties/Managers/DWPackageProperty/Models/DWPackageModel";
import { DWPackagePropertyStore }
    from "Core/GeneralProperties/Managers/DWPackageProperty/Stores/DWPackagePropertyStore";

ko.templates["Core/GeneralProperties/Managers/DWPackageProperty/Templates/DWPackageProperty"] = Template;

export interface IDWPackageRow {
    Id: KnockoutObservable<number>;
}

export class DWPackageProperty extends BaseProperty {
    private _options: KnockoutObservableArray<IPropertyOption>;
    SelectedIds: KnockoutObservableArray<IDWPackageRow>;
    private _pendingIds: number[];

    constructor(property: IPropertyDescription, propertyValue: any, getData: boolean = true) {
        super(property);

        this._options = ko.observableArray<IPropertyOption>([]);
        this.Value = ko.observable<string>(null);
        this.SelectedIds = ko.observableArray<IDWPackageRow>([]);
        this._pendingIds = this.ParseValue(propertyValue);

        if (getData) {
            DWPackagePropertyStore.GetDataWizardPackages().then((result) => {
                const items: IPropertyOption[] = _.map(result,
                    (item: DWPackageModel) => ({ Name: item.Name, Value: item.Id }));
                this._options(items);
                this.HydrateFromPending();
            }).fail(error => {
                new Notifier().Failed(error.message);
            });
        }
    }

    get Options(): KnockoutObservableArray<IPropertyOption> {
        return this._options;
    }

    GetTemplateName(): string {
        return "Core/GeneralProperties/Managers/DWPackageProperty/Templates/DWPackageProperty";
    }

    GetDefaultValue() {
        return null;
    }

    SetValue(propertyValue: any): void {
        this._pendingIds = this.ParseValue(propertyValue);
        if (this._options().length > 0) {
            this.HydrateFromPending();
        }
    }

    IsValid(): boolean {
        if (this.ValueRequired) {
            return this.SelectedIds().some(row => (row.Id() || 0) > 0);
        }
        return true;
    }

    Add = () => {
        const first = this._options()[0];
        const id = first ? first.Value : null;
        this.SelectedIds.push(this.CreateRow(id));
        this.WriteValue();
    }

    RemoveAt = (index: number) => {
        const arr = this.SelectedIds();
        if (index < 0 || index >= arr.length) return;
        arr.splice(index, 1);
        this.SelectedIds(arr.slice());
        this.WriteValue();
    }

    OnRowChange = () => {
        this.WriteValue();
    }

    private ParseValue(propertyValue: any): number[] {
        if (propertyValue == null || propertyValue === '') return [];
        const raw = typeof propertyValue === 'string' ? propertyValue : String(propertyValue);
        return raw.split(',')
            .map(s => parseInt(s.trim(), 10))
            .filter(n => !isNaN(n) && n > 0);
    }

    private HydrateFromPending() {
        const rows = this._pendingIds.map(id => this.CreateRow(id));
        this.SelectedIds(rows);
        this.WriteValue();
    }

    private CreateRow(initial: number): IDWPackageRow {
        return { Id: ko.observable<number>(initial) };
    }

    private BuildValue(): string {
        return this.SelectedIds()
            .map(row => row.Id())
            .filter(v => v != null && v > 0)
            .join(',');
    }

    private WriteValue() {
        const value = this.BuildValue();
        this.Value(value || null);
    }
}
